import instance from "api/instance";

// Create new transfer
const createTransfer = async (transferData) => {
  const response = await instance.post(
    "/reseller/orders/transfer-to-reseller",
    transferData
  );
  
  if (response.status === 200 || response.status === 201) {
    return response.data;
  }
  
  return Promise.reject(response.data);
};

// Get transfers
const getTransfers = async (data) => {
  const response = await instance.get("/reseller/orders/list", {
    params: {
      type: "transfer",
      page: data.page,
      per_page: data.per_page
    }
  });
  
  if (response.status === 200) {
    return response.data;
  }
  
  return Promise.reject(response.data);
};

const transferService = {
  createTransfer,
  getTransfers,
};

export default transferService;